import React, { ElementType, HTMLAttributes } from 'react';

import { TypographyTitleProps as HelperTypographyTitleProps, LevelType } from '../../../helpers';
import { TitleEmotion } from './styles';

export interface Props {
  level: LevelType;
}

export type TypographyTitleProps = Props & HelperTypographyTitleProps;

export const Title: React.FC<TypographyTitleProps & HTMLAttributes<HTMLHeadingElement>> = props => {
  const { children, ...other } = props;

  return (
    <TitleEmotion as={`h${props.level}` as ElementType} {...other}>
      {children}
    </TitleEmotion>
  );
};
